import { render, staticRenderFns } from "./Importador.vue?vue&type=template&id=142d38ee&scoped=true"
import script from "./Importador.vue?vue&type=script&lang=js"
export * from "./Importador.vue?vue&type=script&lang=js"
import style0 from "./Importador.vue?vue&type=style&index=0&id=142d38ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d38ee",
  null
  
)

export default component.exports